<template>
  <Headers ref="headers" @filtered-events="handleFilteredEvents" @loading-state="handleLoadingState"
    @categories-filter="handleCategoriesFilter" @sendErrorText="handleErrorText" @changeMenuState="onChangeMenuState"
    @fetchEvent="fetchEvents" />
  <div :class="{ 'mainPage': true, 'load': loading }">
    <section class="events" v-if="page === ''">
      <div class="container">
        <div class="container__elem container__elem--12">
          <div class="events__wrap">
            <div v-if="events && events.length > 0 && flagNewEvents" class="events__inner" ref="eventsInner">
              <div class="events__item" v-for="(event, index) in events" :key="event.id" @click="fetchEvents(event.id)">
                <div class="events__item-poster" :style="{ backgroundColor: '#' + event.color }">
                  <p class="events__item-time">{{ formatDateTime(event.startTime, event.finishTime) }}<sup
                      v-if="getDayDifference(event.startTime, event.finishTime)">{{
                        getDayDifference(event.startTime,
                          event.finishTime) }}</sup></p>
                  <PosterImage :eventId="event.id" :view="'l'" :posterName="event.posterName" :rect="event.rect" />
                  <template v-if="deviceMobileTry">
                    <MarkersPanel v-if="event.markers != null" :markers="event.markers" :eventId="event.id"
                      :event="event" @open-login-modal="showLoginModal = true"
                      @open-signup-event-modal="openSignUpEvent"
                      @open-signup-event-multi-modal="openSignUpEventMulti" />
                    <img v-if="event.organizer && event.organizer.logo"
                      :src="`/api/pis/v1/images/icons/${event.organizer.logo}`" alt="" class="events__item-logo"
                      style="background-color: gray;" @click="openOrganizerModal($event, event.organizer.id)" />
                  </template>
                </div>
                <div class="events__item-content">
                  <p class="events__item-title">{{ event.shortTitle }}</p>
                  <p class="events__item-text">{{ event.shortDescription }}</p>
                  <div class="events__item-point">
                    <i>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9 16.5002C13.1421 16.5002 16.5 14.9892 16.5 13.1252C16.5 12.1752 15.6278 11.3169 14.2241 10.7036C13.3675 12.2755 12.0613 13.6304 10.4021 14.3394C9.51032 14.7205 8.48968 14.7205 7.59786 14.3394C5.93871 13.6304 4.6325 12.2755 3.77594 10.7036C2.37221 11.3169 1.5 12.1752 1.5 13.1252C1.5 14.9892 4.85786 16.5002 9 16.5002Z"
                          fill="#4BB85A" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3.75 6.38598C3.75 3.68753 6.10051 1.5 9 1.5C11.8995 1.5 14.25 3.68753 14.25 6.38598C14.25 9.06328 12.5744 12.1874 9.96005 13.3047C9.35061 13.5651 8.64939 13.5651 8.03995 13.3047C5.42562 12.1874 3.75 9.06328 3.75 6.38598ZM9 8.25C9.82843 8.25 10.5 7.57843 10.5 6.75C10.5 5.92157 9.82843 5.25 9 5.25C8.17157 5.25 7.5 5.92157 7.5 6.75C7.5 7.57843 8.17157 8.25 9 8.25Z"
                          fill="#4BB85A" />
                      </svg>


                    </i>
                    <p v-if="event.addr" class="events__item-addr">{{ event.addr }}</p>
                    <p v-else class="events__item-addr">Адрес мероприятия</p>
                  </div>
                  <MarkersPanel v-if="event.markers != null && !deviceMobileTry" :markers="event.markers"
                    :eventId="event.id" :event="event" @open-login-modal="showLoginModal = true"
                    @open-signup-event-modal="openSignUpEvent" @open-signup-event-multi-modal="openSignUpEventMulti" />
                  <div v-else-if="screenWidth > 639" style="height:32px"></div>
                  <div class="events__item-fav" :class="{ active: event.favorite }"
                    @click="toggleFav($event, event, false)">
                    <i>
                      <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M3.74957 1.44946C2.64357 1.95502 1.83333 3.15749 1.83333 4.5914C1.83333 6.05633 2.43281 7.18549 3.29219 8.15318C4.00048 8.95074 4.85789 9.61175 5.69408 10.2564C5.89268 10.4095 6.09009 10.5617 6.28403 10.7146C6.63471 10.991 6.94754 11.2337 7.24907 11.4099C7.55076 11.5862 7.79359 11.6667 8 11.6667C8.2064 11.6667 8.44923 11.5862 8.75092 11.4099C9.05245 11.2337 9.36528 10.991 9.71596 10.7146C9.90989 10.5617 10.1073 10.4095 10.3059 10.2564C11.1421 9.61175 11.9995 8.95074 12.7078 8.15318C13.5672 7.18549 14.1667 6.05633 14.1667 4.5914C14.1667 3.15749 13.3564 1.95502 12.2504 1.44946C11.1759 0.958319 9.73222 1.08839 8.36024 2.51382C8.26598 2.61175 8.13592 2.66709 8 2.66709C7.86407 2.66709 7.73401 2.61175 7.63975 2.51382C6.26777 1.08839 4.82404 0.958319 3.74957 1.44946ZM8 1.47255C6.45863 0.0934962 4.73264 -0.0994186 3.33384 0.539976C1.85647 1.21528 0.833328 2.78336 0.833328 4.5914C0.833328 6.36842 1.57366 7.72404 2.54447 8.81721C3.32191 9.69263 4.27348 10.4253 5.11388 11.0724C5.30439 11.2191 5.48918 11.3614 5.66494 11.4999C6.00643 11.7691 6.37302 12.0562 6.74454 12.2733C7.1159 12.4903 7.53973 12.6667 8 12.6667C8.46026 12.6667 8.88409 12.4903 9.25545 12.2733C9.62697 12.0562 9.99356 11.7691 10.335 11.4999C10.5108 11.3614 10.6956 11.2191 10.8861 11.0724C11.7265 10.4253 12.6781 9.69263 13.4555 8.81721C14.4263 7.72404 15.1667 6.36842 15.1667 4.5914C15.1667 2.78336 14.1435 1.21528 12.6662 0.539976C11.2674 -0.0994186 9.54137 0.0934962 8 1.47255Z"
                          fill="#4BB85A" />
                      </svg>

                    </i>
                    <p>{{ event.favoriteCount }}</p>
                  </div>
                  <img v-if="event.organizer && event.organizer.logo && !deviceMobileTry"
                    :src="`/api/pis/v1/images/icons/${event.organizer.logo}`" alt="" class="events__item-logo"
                    style="background-color: gray;" @click="openOrganizerModal($event, event.organizer.id)" />

                </div>
              </div>
            </div>
            <div v-else class="events__placeholder">
              <div class="events__placeholder-inner">
                <p v-if="errorMessage" class="events__error-text">{{ errorMessage }}</p>
                <p v-else-if="!loading" class="events__placeholder-text">
                  Нет запланированных мероприятий {{ this.selectedDateTextPlaceHolder.toLowerCase() }}
                  с выбранными категориями.
                </p>
              </div>
            </div>
            <EventsMenu :activeMenuItem="activeMenuItem" @selectAllEvents="selectAllEvents"
              @selectAccount="selectAccount" @selectCustomFilter="selectCustomFilter" />
          </div>
        </div>
      </div>
    </section>
    <div class="map" v-else-if="page === 'map'">
      <div class="container">
        <div class="container__elem container__elem-12">
          <div class="map__inner">
            <div class="map__wrap">
              <div class="map__info">
                <h2 class="map__info-title">Мероприятие</h2>
                <div class="map__info-item">
                  <img src="../assets/img/metka1.png" alt="" class="map__info-img">
                  <p class="map__info-text">Запланировано </p>
                </div>
                <div class="map__info-item">
                  <img src="../assets/img/metka2.png" alt="" class="map__info-img">
                  <p class="map__info-text">Сейчас идет </p>
                </div>
              </div>
              <div v-if="showEventModal" class="map__event">
                <div class="map__event-img-wrap" :style="{ backgroundColor: '#' + selectedEvent.color }">
                  <PosterImage :eventId="selectedEvent.id" :view="'m'" :posterName="selectedEvent.posterName"
                    :rect="selectedEvent.rect" />
                </div>
                <h2 class="map__event-title">{{ selectedEvent.title }}</h2>
                <div class="map__event-pair">
                  <i>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.84375 1.5625C4.84375 1.30362 4.63388 1.09375 4.375 1.09375C4.11612 1.09375 3.90625 1.30362 3.90625 1.5625V2.54954C3.00667 2.62157 2.41611 2.79836 1.98223 3.23223C1.54836 3.66611 1.37157 4.25667 1.29954 5.15625H13.7005C13.6284 4.25667 13.4516 3.66611 13.0178 3.23223C12.5839 2.79836 11.9933 2.62157 11.0938 2.54954V1.5625C11.0938 1.30362 10.8839 1.09375 10.625 1.09375C10.3661 1.09375 10.1562 1.30362 10.1562 1.5625V2.50806C9.74046 2.5 9.2744 2.5 8.75 2.5H6.25C5.7256 2.5 5.25954 2.5 4.84375 2.50806V1.5625Z"
                        fill="#4BB85A" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.25 7.5C1.25 6.9756 1.25 6.50954 1.25806 6.09375H13.7419C13.75 6.50954 13.75 6.9756 13.75 7.5V8.75C13.75 11.107 13.75 12.2855 13.0178 13.0178C12.2855 13.75 11.107 13.75 8.75 13.75H6.25C3.89298 13.75 2.71447 13.75 1.98223 13.0178C1.25 12.2855 1.25 11.107 1.25 8.75V7.5ZM10.625 8.75C10.9702 8.75 11.25 8.47018 11.25 8.125C11.25 7.77982 10.9702 7.5 10.625 7.5C10.2798 7.5 10 7.77982 10 8.125C10 8.47018 10.2798 8.75 10.625 8.75ZM10.625 11.25C10.9702 11.25 11.25 10.9702 11.25 10.625C11.25 10.2798 10.9702 10 10.625 10C10.2798 10 10 10.2798 10 10.625C10 10.9702 10.2798 11.25 10.625 11.25ZM8.125 8.125C8.125 8.47018 7.84518 8.75 7.5 8.75C7.15482 8.75 6.875 8.47018 6.875 8.125C6.875 7.77982 7.15482 7.5 7.5 7.5C7.84518 7.5 8.125 7.77982 8.125 8.125ZM8.125 10.625C8.125 10.9702 7.84518 11.25 7.5 11.25C7.15482 11.25 6.875 10.9702 6.875 10.625C6.875 10.2798 7.15482 10 7.5 10C7.84518 10 8.125 10.2798 8.125 10.625ZM4.375 8.75C4.72018 8.75 5 8.47018 5 8.125C5 7.77982 4.72018 7.5 4.375 7.5C4.02982 7.5 3.75 7.77982 3.75 8.125C3.75 8.47018 4.02982 8.75 4.375 8.75ZM4.375 11.25C4.72018 11.25 5 10.9702 5 10.625C5 10.2798 4.72018 10 4.375 10C4.02982 10 3.75 10.2798 3.75 10.625C3.75 10.9702 4.02982 11.25 4.375 11.25Z"
                        fill="#4BB85A" />
                    </svg>
                  </i>
                  <p class="map__event-date">{{ formatDatePopup(selectedEvent.startTime) }}</p>
                </div>
                <div class="map__event-pair">
                  <i>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.24891 2.06199C3.62529 1.25 4.91686 1.25 7.5 1.25C10.0831 1.25 11.3747 1.25 11.7511 2.06199C11.7834 2.13179 11.8107 2.20428 11.8327 2.27881C12.0884 3.14581 11.1751 4.15069 9.34856 6.16046L8.125 7.5L9.34856 8.83954C11.1751 10.8493 12.0884 11.8542 11.8327 12.7212C11.8107 12.7957 11.7834 12.8682 11.7511 12.938C11.3747 13.75 10.0831 13.75 7.5 13.75C4.91686 13.75 3.62529 13.75 3.24891 12.938C3.21655 12.8682 3.18926 12.7957 3.16728 12.7212C2.9116 11.8542 3.82488 10.8493 5.65144 8.83954L6.875 7.5L5.65144 6.16046C3.82488 4.15069 2.9116 3.14581 3.16728 2.27881C3.18926 2.20428 3.21655 2.13179 3.24891 2.06199ZM6.25 11.0938C5.99112 11.0938 5.78125 11.3036 5.78125 11.5625C5.78125 11.8214 5.99112 12.0312 6.25 12.0312H8.75C9.00888 12.0312 9.21875 11.8214 9.21875 11.5625C9.21875 11.3036 9.00888 11.0938 8.75 11.0938H6.25ZM5.78125 3.4375C5.78125 3.17862 5.99112 2.96875 6.25 2.96875H8.75C9.00888 2.96875 9.21875 3.17862 9.21875 3.4375C9.21875 3.69638 9.00888 3.90625 8.75 3.90625H6.25C5.99112 3.90625 5.78125 3.69638 5.78125 3.4375Z"
                        fill="#4BB85A" />
                    </svg>

                  </i>
                  <p class="map__event-time">{{ formatTimePopup(selectedEvent.startTime, selectedEvent.finishTime) }}
                  </p>
                </div>
                <div class="map__event-pair">
                  <i>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.5 13.7502C10.9518 13.7502 13.75 12.491 13.75 10.9377C13.75 10.146 13.0232 9.43078 11.8534 8.91968C11.1396 10.2296 10.0511 11.3586 8.66845 11.9495C7.92527 12.2671 7.07473 12.2671 6.33155 11.9495C4.94892 11.3586 3.86041 10.2296 3.14661 8.91968C1.97685 9.43078 1.25 10.146 1.25 10.9377C1.25 12.491 4.04822 13.7502 7.5 13.7502Z"
                        fill="#4BB85A" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M3.125 5.32165C3.125 3.07294 5.08375 1.25 7.5 1.25C9.91625 1.25 11.875 3.07294 11.875 5.32165C11.875 7.55273 10.4787 10.1562 8.30004 11.0872C7.79217 11.3043 7.20783 11.3043 6.69996 11.0872C4.52135 10.1562 3.125 7.55273 3.125 5.32165ZM7.5 6.875C8.19036 6.875 8.75 6.31536 8.75 5.625C8.75 4.93464 8.19036 4.375 7.5 4.375C6.80964 4.375 6.25 4.93464 6.25 5.625C6.25 6.31536 6.80964 6.875 7.5 6.875Z"
                        fill="#4BB85A" />
                    </svg>
                  </i>
                  <p class="map__event-place">{{ selectedEvent.addr }}</p>
                </div>
                <button class="map__event-link" @click="fetchEvents(selectedEvent.id)">
                  Перейти к мероприятию
                </button>
              </div>
              <div class="map__content" ref="mapContainerList" style="position: relative;"></div>
            </div>
            <EventsMenu :activeMenuItem="activeMenuItem" @selectAllEvents="selectAllEvents"
              @selectAccount="selectAccount" @selectCustomFilter="selectCustomFilter" />
          </div>
        </div>
      </div>
    </div>
    <div class="calendar" v-else-if="page === 'calendar'">
      <div class="container">
        <div class="container__elem container__elem--12">
          <div class="calendar__month">
            <div class="month">
              <div class="month__header">
                <div class="events__menu-wrap">
                  <EventsMenu :activeMenuItem="activeMenuItem" @selectAllEvents="selectAllEvents"
                    @selectAccount="selectAccount" @selectCustomFilter="selectCustomFilter" />
                </div>
                <div class="month__header-select">
                  <button @click="prevMonth" :disabled="isPrevMonthDisabled">
                    <i>
                      <svg width="31" height="44" viewBox="0 0 31 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.78802 19.6127L25.1832 2.56885C27.1581 1.06579 30 2.47425 30 4.95612V39.0439C30 41.5257 27.1581 42.9342 25.1832 41.4312L2.78803 24.3873C1.21048 23.1867 1.21048 20.8133 2.78802 19.6127Z"
                          stroke="#232323" fill="#000" stroke-width="2" />
                      </svg>

                    </i>
                  </button>
                  <span>{{ currentMonth }}</span>
                  <button @click="nextMonth" :disabled="isNextMonthDisabled">
                    <i>
                      <svg width="31" height="44" viewBox="0 0 31 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M28.212 24.3873L5.81685 41.4311C3.84188 42.9342 1 41.5257 1 39.0439L1 4.95612C1 2.47425 3.84187 1.06579 5.81684 2.56885L28.212 19.6127C29.7895 20.8133 29.7895 23.1867 28.212 24.3873Z"
                          stroke="#232323" fill="#000" stroke-width="2" />
                      </svg>

                    </i>
                  </button>
                </div>
              </div>
              <div class="month__weekdays">
                <div v-for="day in weekdays" :key="day" class="month__weekday">{{ day.dayOfWeek }}</div>
              </div>
              <div class="month__days">
                <div v-for="(day, index) in daysInMonth" :key="index" v-bind:class="[
                  'month__day',
                  isToday(new Date(day.date)) ? 'today' : '',
                  getDayClass(daysInMonth),
                  isPastDay(new Date(day.date)) ? 'past' : ''
                ]">
                  <div class="month__date">{{ new Date(day.date).getDate() }}</div>
                  <div class="month__events" v-if="!loading">
                    <template v-if="day.events.length > 2">
                      <div class="month__events-count-container"
                        @click="selectedDay = new Date(day.date); showPopupEvents(day.events, day.date)">
                        <img src="../assets/img/popupIcon.png" class="month__events-img">
                        <span class="month__events-count">{{ day.events.length }}</span>
                        <p class="month__events-count-text">Показать все </p>
                      </div>
                    </template>
                    <template v-else>
                      <div v-for="event in day.events" :key="event.id" @click="fetchEvents(event.id)"
                        class="month__event">
                        <p class="month__event-title">{{ event.shortTitle }}</p>
                        <p class="month__event-time">{{ formatDateTime(event.startTime, event.finishTime) }}<sup
                            v-if="getDayDifference(event.startTime, event.finishTime)">{{
                              getDayDifference(event.startTime, event.finishTime) }}</sup></p>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
    <transition>
      <div class="popupEvents" v-if="showEventsPopup" @click.self="hidePopup">
        <div class="container">
          <div class="container__elem container__elem--12">
            <div class="popupEvents__inner">
              <div class="popupEvents__content" :style="isPopupVisible ? 'filter: brightness(0.6)' : ''">
                <div class="popupEvents__head">
                  <h2 class="popupEvents__title">{{ currentDateText }}</h2>
                  <button class="popupEvents__close" @click="hidePopupEvents">
                    <i>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5455 1.45508L1.45459 14.546M1.45459 1.45508L14.5455 14.546" stroke="#232323"
                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </i>
                  </button>
                </div>
                <ul class="popupEvents__list">
                  <div class="events__item" v-for="(event, index) in currentDayEvents" :key="index"
                    @click="fetchEvents(event.id)">
                    <div class="events__item-poster">
                      <p class="events__item-time">{{ formatDateTime(event.startTime, event.finishTime) }}<sup
                          v-if="getDayDifference(event.startTime, event.finishTime)">{{
                            getDayDifference(event.startTime,
                              event.finishTime) }}</sup></p>
                      <template v-if="deviceMobileTry">
                        <MarkersPanel @refresh="refreshPlaces" v-if="event.markers != null" :markers="event.markers"
                          :eventId="event.id" @open-login-modal="showLoginModal = true" />
                        <img v-if="event.organizer && event.organizer.logo"
                          :src="`/api/pis/v1/images/icons/${event.organizer.logo}`" alt="" class="events__item-logo"
                          style="background-color: gray;" @click="openOrganizerModal($event, event.organizer.id)" />
                      </template>
                      <PosterImage :eventId="event.id" :view="'l'" :posterName="event.posterName" :rect="event.rect" />
                    </div>
                    <div class="events__item-content">
                      <p class="events__item-title">{{ event.shortTitle }}</p>
                      <p class="events__item-text">{{ event.shortDescription }}</p>
                      <div class="events__item-point">
                        <i>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M9 16.5002C13.1421 16.5002 16.5 14.9892 16.5 13.1252C16.5 12.1752 15.6278 11.3169 14.2241 10.7036C13.3675 12.2755 12.0613 13.6304 10.4021 14.3394C9.51032 14.7205 8.48968 14.7205 7.59786 14.3394C5.93871 13.6304 4.6325 12.2755 3.77594 10.7036C2.37221 11.3169 1.5 12.1752 1.5 13.1252C1.5 14.9892 4.85786 16.5002 9 16.5002Z"
                              fill="#4BB85A" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M3.75 6.38598C3.75 3.68753 6.10051 1.5 9 1.5C11.8995 1.5 14.25 3.68753 14.25 6.38598C14.25 9.06328 12.5744 12.1874 9.96005 13.3047C9.35061 13.5651 8.64939 13.5651 8.03995 13.3047C5.42562 12.1874 3.75 9.06328 3.75 6.38598ZM9 8.25C9.82843 8.25 10.5 7.57843 10.5 6.75C10.5 5.92157 9.82843 5.25 9 5.25C8.17157 5.25 7.5 5.92157 7.5 6.75C7.5 7.57843 8.17157 8.25 9 8.25Z"
                              fill="#4BB85A" />
                          </svg>


                        </i>
                        <p v-if="event.addr" class="events__item-addr">{{ event.addr }}</p>
                        <p v-else class="events__item-addr">Адрес мероприятия</p>
                      </div>
                      <MarkersPanel @refresh="refreshPlaces" v-if="event.markers != null && !deviceMobileTry"
                        :markers="event.markers" :eventId="event.id" @open-login-modal="showLoginModal = true" />
                      <div class="events__item-fav" :class="{ active: event.favorite }"
                        @click="toggleFav($event, event, false)">
                        <i>
                          <svg width="16" height="13" viewBox="0 0 16 13" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M3.74957 1.44946C2.64357 1.95502 1.83333 3.15749 1.83333 4.5914C1.83333 6.05633 2.43281 7.18549 3.29219 8.15318C4.00048 8.95074 4.85789 9.61175 5.69408 10.2564C5.89268 10.4095 6.09009 10.5617 6.28403 10.7146C6.63471 10.991 6.94754 11.2337 7.24907 11.4099C7.55076 11.5862 7.79359 11.6667 8 11.6667C8.2064 11.6667 8.44923 11.5862 8.75092 11.4099C9.05245 11.2337 9.36528 10.991 9.71596 10.7146C9.90989 10.5617 10.1073 10.4095 10.3059 10.2564C11.1421 9.61175 11.9995 8.95074 12.7078 8.15318C13.5672 7.18549 14.1667 6.05633 14.1667 4.5914C14.1667 3.15749 13.3564 1.95502 12.2504 1.44946C11.1759 0.958319 9.73222 1.08839 8.36024 2.51382C8.26598 2.61175 8.13592 2.66709 8 2.66709C7.86407 2.66709 7.73401 2.61175 7.63975 2.51382C6.26777 1.08839 4.82404 0.958319 3.74957 1.44946ZM8 1.47255C6.45863 0.0934962 4.73264 -0.0994186 3.33384 0.539976C1.85647 1.21528 0.833328 2.78336 0.833328 4.5914C0.833328 6.36842 1.57366 7.72404 2.54447 8.81721C3.32191 9.69263 4.27348 10.4253 5.11388 11.0724C5.30439 11.2191 5.48918 11.3614 5.66494 11.4999C6.00643 11.7691 6.37302 12.0562 6.74454 12.2733C7.1159 12.4903 7.53973 12.6667 8 12.6667C8.46026 12.6667 8.88409 12.4903 9.25545 12.2733C9.62697 12.0562 9.99356 11.7691 10.335 11.4999C10.5108 11.3614 10.6956 11.2191 10.8861 11.0724C11.7265 10.4253 12.6781 9.69263 13.4555 8.81721C14.4263 7.72404 15.1667 6.36842 15.1667 4.5914C15.1667 2.78336 14.1435 1.21528 12.6662 0.539976C11.2674 -0.0994186 9.54137 0.0934962 8 1.47255Z"
                              fill="#4BB85A" />
                          </svg>

                        </i>
                        <p>{{ event.favoriteCount }}</p>
                      </div>
                      <img v-if="event.organizer && event.organizer.logo && !deviceMobileTry"
                        :src="`/api/pis/v1/images/icons/${event.organizer.logo}`" alt="" class="events__item-logo"
                        style="background-color: gray;" @click="openOrganizerModal($event, event.organizer.id)" />

                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition>
      <div v-if="isPopupVisible" class="popup" ref="popup">
        <div class="event__close" @click="closePopup">
          <i>
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 1.5L19.5 19.5M1.5 19.5L19.5 1.5" stroke="#333333" stroke-width="1.5" />
            </svg>
          </i>
        </div>
        <div v-if="isLinkCopied" class="event__copy-message">Ссылка скопирована!</div>
        <div class="event__wrap">
          <div class="event">
            <div class="event__inner">
              <div class="event__content"
                :class="{ 'event__content--schedule': selectedEvent.scheduleGroup && !deviceMobile }">
                <h3 v-if="!deviceMobile" class="event__title">{{ selectedEvent.title }}</h3>
                <p v-if="selectedEvent.ageMinLimit" class="event__agelimit">{{ selectedEvent.ageMinLimit }}+</p>
                <div v-if="!deviceMobile" class="event__dateTime">
                  <i>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.5 8C0.5 4.46447 0.5 2.6967 1.59835 1.59835C2.6967 0.5 4.46447 0.5 8 0.5C11.5355 0.5 13.3033 0.5 14.4017 1.59835C15.5 2.6967 15.5 4.46447 15.5 8C15.5 11.5355 15.5 13.3033 14.4017 14.4017C13.3033 15.5 11.5355 15.5 8 15.5C4.46447 15.5 2.6967 15.5 1.59835 14.4017C0.5 13.3033 0.5 11.5355 0.5 8Z"
                        fill="#4BB85A" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8 4.4375C8.31066 4.4375 8.5625 4.68934 8.5625 5V7.767L10.2727 9.47725C10.4924 9.69692 10.4924 10.0531 10.2727 10.2727C10.0531 10.4924 9.69692 10.4924 9.47725 10.2727L7.60225 8.39775C7.49676 8.29226 7.4375 8.14918 7.4375 8V5C7.4375 4.68934 7.68934 4.4375 8 4.4375Z"
                        fill="white" />
                    </svg>

                  </i>
                  <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).time }}</p>
                </div>
                <div v-if="!deviceMobile" class="event__dateTime">
                  <i>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M4.8125 0.875C4.8125 0.56434 4.56066 0.3125 4.25 0.3125C3.93934 0.3125 3.6875 0.56434 3.6875 0.875V2.05944C2.608 2.14588 1.89933 2.35803 1.37868 2.87868C0.858031 3.39933 0.645885 4.108 0.559443 5.1875H15.4406C15.3541 4.108 15.142 3.39933 14.6213 2.87868C14.1007 2.35803 13.392 2.14588 12.3125 2.05944V0.875C12.3125 0.56434 12.0607 0.3125 11.75 0.3125C11.4393 0.3125 11.1875 0.56434 11.1875 0.875V2.00968C10.6886 2 10.1293 2 9.5 2H6.5C5.87072 2 5.31145 2 4.8125 2.00968V0.875Z"
                        fill="#4BB85A" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0.5 8C0.5 7.37072 0.5 6.81145 0.509677 6.3125H15.4903C15.5 6.81145 15.5 7.37072 15.5 8V9.5C15.5 12.3284 15.5 13.7426 14.6213 14.6213C13.7426 15.5 12.3284 15.5 9.5 15.5H6.5C3.67157 15.5 2.25736 15.5 1.37868 14.6213C0.5 13.7426 0.5 12.3284 0.5 9.5V8ZM11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5ZM11.75 12.5C12.1642 12.5 12.5 12.1642 12.5 11.75C12.5 11.3358 12.1642 11 11.75 11C11.3358 11 11 11.3358 11 11.75C11 12.1642 11.3358 12.5 11.75 12.5ZM8.75 8.75C8.75 9.16421 8.41421 9.5 8 9.5C7.58579 9.5 7.25 9.16421 7.25 8.75C7.25 8.33579 7.58579 8 8 8C8.41421 8 8.75 8.33579 8.75 8.75ZM8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11C8.41421 11 8.75 11.3358 8.75 11.75ZM4.25 9.5C4.66421 9.5 5 9.16421 5 8.75C5 8.33579 4.66421 8 4.25 8C3.83579 8 3.5 8.33579 3.5 8.75C3.5 9.16421 3.83579 9.5 4.25 9.5ZM4.25 12.5C4.66421 12.5 5 12.1642 5 11.75C5 11.3358 4.66421 11 4.25 11C3.83579 11 3.5 11.3358 3.5 11.75C3.5 12.1642 3.83579 12.5 4.25 12.5Z"
                        fill="#4BB85A" />
                    </svg>

                  </i>
                  <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).date }}</p>
                </div>
                <Schedule v-if="selectedEvent.scheduleGroup && !deviceMobile" :schedules="selectedEvent.schedules"
                  :scheduleIndex="selectedEvent.scheduleIndex" :run="selectedEvent.run" />
                <h2 class="event__info-name">Организатор</h2>
                <div class="event__org">
                  <img class="event__org-icon" :src="`/api/pis/v1/images/icons/${selectedEvent.organizer.logo}`" alt=""
                    @click="openOrganizerModal($event, selectedEvent.organizer.id)">
                  <p class="event__org-text">{{ selectedEvent.organizer.title }}</p>
                </div>
                <h2 class="event__info-name">Адрес проведения мероприятия</h2>
                <div class="event__address">
                  <i>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12 22.0003C17.5228 22.0003 22 19.9856 22 17.5003C22 16.2337 20.837 15.0892 18.9654 14.2715C17.8233 16.3673 16.0817 18.1738 13.8695 19.1192C12.6804 19.6274 11.3196 19.6274 10.1305 19.1192C7.91828 18.1738 6.17666 16.3673 5.03458 14.2715C3.16295 15.0892 2 16.2337 2 17.5003C2 19.9856 6.47715 22.0003 12 22.0003Z"
                        fill="#4BB85A" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M5 8.51464C5 4.9167 8.13401 2 12 2C15.866 2 19 4.9167 19 8.51464C19 12.0844 16.7658 16.2499 13.2801 17.7396C12.4675 18.0868 11.5325 18.0868 10.7199 17.7396C7.23416 16.2499 5 12.0844 5 8.51464ZM12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11Z"
                        fill="#4BB85A" />
                    </svg>

                  </i>
                  <p>{{ selectedEvent.addr }}</p>
                </div>
                <div class="event__scroll">
                  <button :class="{ active: eventMapShow }" class="event__map-btn"
                    @click="eventMapShow = !eventMapShow, initMap()">
                    <p>Показать карту</p>
                    <i>
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.19995 4.56665L4.99995 1.36665L1.79995 4.56665" stroke="#4BB85A" stroke-width="1.5"
                          stroke-linecap="square" />
                      </svg>

                    </i>
                  </button>
                  <div class="event__map" :class="{ show: eventMapShow }" ref="mapContainer"
                    style="position: relative;">
                  </div>
                  <h2 class="event__info-name">Описание мероприятия</h2>
                  <p class="event__info-text" v-html="formattedDescr(selectedEvent.description)"></p>
                </div>
                <div v-if="selectedEvent.link" class="event__info-source">
                  <p>Источник:</p>
                  <a :href="selectedEvent.link">{{ selectedEvent.link }}</a>
                </div>
              </div>
              <div class="event__side">
                <div class="event__poster-wrap" :style="{ backgroundColor: '#' + selectedEvent.color }">
                  <PosterImage :eventId="selectedEvent.id" :view="'c'" :posterName="selectedEvent.posterName"
                    :rect="selectedEvent.rect" />
                  <div class="event__poster-block">
                    <div class="event__fav" :class="{ active: selectedEvent.favorite }"
                      @click="toggleFav($event, selectedEvent, true)">
                      <i>
                        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.74957 1.44946C2.64357 1.95502 1.83333 3.15749 1.83333 4.5914C1.83333 6.05633 2.43281 7.18549 3.29219 8.15318C4.00048 8.95074 4.85789 9.61175 5.69408 10.2564C5.89268 10.4095 6.09009 10.5617 6.28403 10.7146C6.63471 10.991 6.94754 11.2337 7.24907 11.4099C7.55076 11.5862 7.79359 11.6667 8 11.6667C8.2064 11.6667 8.44923 11.5862 8.75092 11.4099C9.05245 11.2337 9.36528 10.991 9.71596 10.7146C9.90989 10.5617 10.1073 10.4095 10.3059 10.2564C11.1421 9.61175 11.9995 8.95074 12.7078 8.15318C13.5672 7.18549 14.1667 6.05633 14.1667 4.5914C14.1667 3.15749 13.3564 1.95502 12.2504 1.44946C11.1759 0.958319 9.73222 1.08839 8.36024 2.51382C8.26598 2.61175 8.13592 2.66709 8 2.66709C7.86407 2.66709 7.73401 2.61175 7.63975 2.51382C6.26777 1.08839 4.82404 0.958319 3.74957 1.44946ZM8 1.47255C6.45863 0.0934962 4.73264 -0.0994186 3.33384 0.539976C1.85647 1.21528 0.833328 2.78336 0.833328 4.5914C0.833328 6.36842 1.57366 7.72404 2.54447 8.81721C3.32191 9.69263 4.27348 10.4253 5.11388 11.0724C5.30439 11.2191 5.48918 11.3614 5.66494 11.4999C6.00643 11.7691 6.37302 12.0562 6.74454 12.2733C7.1159 12.4903 7.53973 12.6667 8 12.6667C8.46026 12.6667 8.88409 12.4903 9.25545 12.2733C9.62697 12.0562 9.99356 11.7691 10.335 11.4999C10.5108 11.3614 10.6956 11.2191 10.8861 11.0724C11.7265 10.4253 12.6781 9.69263 13.4555 8.81721C14.4263 7.72404 15.1667 6.36842 15.1667 4.5914C15.1667 2.78336 14.1435 1.21528 12.6662 0.539976C11.2674 -0.0994186 9.54137 0.0934962 8 1.47255Z"
                            fill="#4BB85A" />
                        </svg>

                      </i>
                      <p>{{ selectedEvent.favoriteCount }}</p>
                    </div>
                    <div class="event__link" @click="shareEvent">
                      <i>
                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.72004 0.746026C6.72223 1.0049 6.51415 1.21654 6.25528 1.21873C5.18678 1.22779 4.39931 1.26254 3.78926 1.38203C3.1923 1.49897 2.79989 1.69083 2.49699 1.99373C2.14083 2.34988 1.93646 2.83174 1.82901 3.63096C1.71975 4.44367 1.71875 5.5116 1.71875 6.99837C1.71875 8.48515 1.71975 9.55307 1.82901 10.3658C1.93646 11.165 2.14083 11.6469 2.49699 12.003C2.85314 12.3592 3.335 12.5635 4.13422 12.671C4.94693 12.7803 6.01486 12.7813 7.50163 12.7813C8.98841 12.7813 10.0563 12.7803 10.869 12.671C11.6683 12.5635 12.1501 12.3592 12.5063 12.003C12.8092 11.7001 13.001 11.3077 13.118 10.7107C13.2375 10.1007 13.2722 9.31322 13.2813 8.24472C13.2835 7.98585 13.4951 7.77777 13.754 7.77996C14.0128 7.78216 14.2209 7.9938 14.2187 8.25267C14.2097 9.31793 14.1762 10.1855 14.038 10.891C13.8972 11.6095 13.642 12.1931 13.1692 12.6659C12.6098 13.2253 11.8971 13.4787 10.994 13.6001C10.1116 13.7188 8.98062 13.7188 7.53749 13.7188H7.46577C6.02264 13.7188 4.8917 13.7188 4.0093 13.6001C3.10612 13.4787 2.39345 13.2253 1.83407 12.6659C1.2747 12.1066 1.0213 11.3939 0.899871 10.4907C0.781236 9.6083 0.781242 8.47736 0.78125 7.03423V6.96251C0.781242 5.51938 0.781236 4.38844 0.899871 3.50604C1.0213 2.60286 1.2747 1.89019 1.83407 1.33081C2.30689 0.857997 2.89049 0.602768 3.60904 0.462017C4.31451 0.323831 5.18207 0.290299 6.24733 0.281267C6.5062 0.279072 6.71784 0.487152 6.72004 0.746026ZM10.2935 0.418544C10.4766 0.235486 10.7734 0.235486 10.9565 0.418544L14.0815 3.54354C14.2645 3.7266 14.2645 4.0234 14.0815 4.20646L10.9565 7.33146C10.7734 7.51452 10.4766 7.51452 10.2935 7.33146C10.1105 7.1484 10.1105 6.8516 10.2935 6.66854L12.6183 4.34375H8.75C7.78033 4.34375 7.208 4.81688 7.00753 5.01833L6.88742 5.13902L6.76833 5.25752C6.56688 5.45799 6.09375 6.03033 6.09375 7V8.875C6.09375 9.13388 5.88388 9.34375 5.625 9.34375C5.36612 9.34375 5.15625 9.13388 5.15625 8.875V7C5.15625 5.69764 5.79814 4.90039 6.10703 4.59301C6.10703 4.59301 6.10703 4.59301 6.10703 4.59301L6.22611 4.4745L6.343 4.35703C6.65039 4.04815 7.44763 3.40625 8.75 3.40625H12.6183L10.2935 1.08146C10.1105 0.898398 10.1105 0.601602 10.2935 0.418544Z"
                            fill="#333333" />
                        </svg>


                      </i>
                    </div>
                  </div>
                </div>
                <div class="event__subinfo">
                  <div class="event__subinfo-views" v-if="selectedEvent.viewCount != null">
                    <i>
                      <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.5 3.15625C6.20558 3.15625 5.15625 4.20558 5.15625 5.5C5.15625 6.79442 6.20558 7.84375 7.5 7.84375C8.79442 7.84375 9.84375 6.79442 9.84375 5.5C9.84375 4.20558 8.79442 3.15625 7.5 3.15625ZM6.09375 5.5C6.09375 4.72335 6.72335 4.09375 7.5 4.09375C8.27665 4.09375 8.90625 4.72335 8.90625 5.5C8.90625 6.27665 8.27665 6.90625 7.5 6.90625C6.72335 6.90625 6.09375 6.27665 6.09375 5.5Z"
                          fill="#B1B3B9" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M7.5 0.03125C4.67867 0.03125 2.77831 1.72137 1.67535 3.15429L1.65546 3.18013C1.40602 3.50408 1.17629 3.80245 1.02043 4.15525C0.853528 4.53304 0.78125 4.94481 0.78125 5.5C0.78125 6.05519 0.853528 6.46696 1.02043 6.84475C1.17629 7.19755 1.40603 7.49592 1.65547 7.81988L1.67535 7.84571C2.77831 9.27863 4.67867 10.9688 7.5 10.9688C10.3213 10.9688 12.2217 9.27863 13.3246 7.84571L13.3445 7.81989C13.594 7.49593 13.8237 7.19756 13.9796 6.84475C14.1465 6.46696 14.2188 6.05519 14.2188 5.5C14.2188 4.94481 14.1465 4.53304 13.9796 4.15525C13.8237 3.80244 13.594 3.50407 13.3445 3.18011L13.3246 3.15429C12.2217 1.72137 10.3213 0.03125 7.5 0.03125ZM2.41826 3.72612C3.43665 2.40307 5.09397 0.96875 7.5 0.96875C9.90603 0.96875 11.5634 2.40307 12.5817 3.72612C12.8559 4.08224 13.0164 4.29504 13.122 4.53409C13.2207 4.75751 13.2812 5.03058 13.2812 5.5C13.2812 5.96942 13.2207 6.24249 13.122 6.46591C13.0164 6.70497 12.8559 6.91776 12.5817 7.27388C11.5634 8.59693 9.90603 10.0312 7.5 10.0312C5.09397 10.0312 3.43665 8.59693 2.41826 7.27388C2.14415 6.91776 1.98358 6.70496 1.87797 6.46591C1.77927 6.24249 1.71875 5.96942 1.71875 5.5C1.71875 5.03058 1.77927 4.75751 1.87797 4.53409C1.98358 4.29504 2.14415 4.08224 2.41826 3.72612Z"
                          fill="#B1B3B9" />
                      </svg>

                    </i>
                    <span>{{ selectedEvent.viewCount }}</span>
                  </div>
                  <div class="event__subinfo-erid" v-if="selectedEvent.erid != null">
                    <span>Erid:&nbsp;</span><span>{{ selectedEvent.erid }}</span>
                  </div>
                </div>
                <div class="event__side-scroll">
                  <div class="event__side-info">
                    <h3 v-if="deviceMobile" class="event__title">{{ selectedEvent.title }}</h3>
                    <div v-if="deviceMobile" class="event__dateTime">
                      <i>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M0.5 8C0.5 4.46447 0.5 2.6967 1.59835 1.59835C2.6967 0.5 4.46447 0.5 8 0.5C11.5355 0.5 13.3033 0.5 14.4017 1.59835C15.5 2.6967 15.5 4.46447 15.5 8C15.5 11.5355 15.5 13.3033 14.4017 14.4017C13.3033 15.5 11.5355 15.5 8 15.5C4.46447 15.5 2.6967 15.5 1.59835 14.4017C0.5 13.3033 0.5 11.5355 0.5 8Z"
                            fill="#4BB85A" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M8 4.4375C8.31066 4.4375 8.5625 4.68934 8.5625 5V7.767L10.2727 9.47725C10.4924 9.69692 10.4924 10.0531 10.2727 10.2727C10.0531 10.4924 9.69692 10.4924 9.47725 10.2727L7.60225 8.39775C7.49676 8.29226 7.4375 8.14918 7.4375 8V5C7.4375 4.68934 7.68934 4.4375 8 4.4375Z"
                            fill="white" />
                        </svg>

                      </i>
                      <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).time }}</p>
                    </div>
                    <div v-if="deviceMobile" class="event__dateTime">
                      <i>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M4.8125 0.875C4.8125 0.56434 4.56066 0.3125 4.25 0.3125C3.93934 0.3125 3.6875 0.56434 3.6875 0.875V2.05944C2.608 2.14588 1.89933 2.35803 1.37868 2.87868C0.858031 3.39933 0.645885 4.108 0.559443 5.1875H15.4406C15.3541 4.108 15.142 3.39933 14.6213 2.87868C14.1007 2.35803 13.392 2.14588 12.3125 2.05944V0.875C12.3125 0.56434 12.0607 0.3125 11.75 0.3125C11.4393 0.3125 11.1875 0.56434 11.1875 0.875V2.00968C10.6886 2 10.1293 2 9.5 2H6.5C5.87072 2 5.31145 2 4.8125 2.00968V0.875Z"
                            fill="#4BB85A" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M0.5 8C0.5 7.37072 0.5 6.81145 0.509677 6.3125H15.4903C15.5 6.81145 15.5 7.37072 15.5 8V9.5C15.5 12.3284 15.5 13.7426 14.6213 14.6213C13.7426 15.5 12.3284 15.5 9.5 15.5H6.5C3.67157 15.5 2.25736 15.5 1.37868 14.6213C0.5 13.7426 0.5 12.3284 0.5 9.5V8ZM11.75 9.5C12.1642 9.5 12.5 9.16421 12.5 8.75C12.5 8.33579 12.1642 8 11.75 8C11.3358 8 11 8.33579 11 8.75C11 9.16421 11.3358 9.5 11.75 9.5ZM11.75 12.5C12.1642 12.5 12.5 12.1642 12.5 11.75C12.5 11.3358 12.1642 11 11.75 11C11.3358 11 11 11.3358 11 11.75C11 12.1642 11.3358 12.5 11.75 12.5ZM8.75 8.75C8.75 9.16421 8.41421 9.5 8 9.5C7.58579 9.5 7.25 9.16421 7.25 8.75C7.25 8.33579 7.58579 8 8 8C8.41421 8 8.75 8.33579 8.75 8.75ZM8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11C8.41421 11 8.75 11.3358 8.75 11.75ZM4.25 9.5C4.66421 9.5 5 9.16421 5 8.75C5 8.33579 4.66421 8 4.25 8C3.83579 8 3.5 8.33579 3.5 8.75C3.5 9.16421 3.83579 9.5 4.25 9.5ZM4.25 12.5C4.66421 12.5 5 12.1642 5 11.75C5 11.3358 4.66421 11 4.25 11C3.83579 11 3.5 11.3358 3.5 11.75C3.5 12.1642 3.83579 12.5 4.25 12.5Z"
                            fill="#4BB85A" />
                        </svg>

                      </i>
                      <p>{{ formatDateTimeForPopup(selectedEvent.startTime, selectedEvent.finishTime).date }}</p>
                    </div>
                    <Schedule v-if="selectedEvent.scheduleGroup && deviceMobile" :schedules="selectedEvent.schedules" />

                    <div v-if="!deviceMobile" class="event__blocks">
                      <div v-for="(block, index) in selectedEvent.blocks" :key="index" class="event__block">
                        <!-- Вывод информации о блоке -->
                        <div v-for="(info, idx) in block.info" :key="idx" class="event__info">
                          <template v-if="info.type === 'message'">
                            <p>{{ info.message }}</p>
                          </template>
                          <template v-if="info.type === 'cost'">
                            <p class="event__block-price">Цена</p>
                            <p class="event__block-cost">{{ info.cost }}</p>
                          </template>
                          <template v-if="info.type === 'label_count'">
                            <div class="event__block-flex">
                              <p>{{ info.label }}</p>
                              <p class="event__block-count">{{ info.count }}</p>
                            </div>
                          </template>
                        </div>

                        <!-- Вывод кнопок взаимодействия -->
                        <div v-if="block.interact" class="event__interact">
                          <template v-if="block.interact.type === 'button'">
                            <button class="login__btn" :disabled="isLoading"
                              :class="{ 'login__btn--loading': isLoading, 'registered': beRegistered, 'registeredSuccess': beRegisteredSuccess }"
                              v-if="block.interact.action.type != 'phone'"
                              @click="handleAction(block.interact, selectedEvent)">

                              {{ isLoading ? 'Регистрируем…' : (this.errorText || block.interact.label) }}
                            </button>
                            <a v-else :href="'tel:' + block.interact.action.phone">
                              Позвонить
                            </a>
                          </template>

                          <template v-if="block.interact.type === 'button_count'">
                            <div class="event__counter">
                              <button @click="updateCount(block, -1)" :disabled="block.interact.currentCount <= 0">
                                <i>
                                  <svg width="8" height="1" viewBox="0 0 8 1" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.5 0.5H7.5" stroke="#333333" />
                                  </svg>
                                </i>
                              </button>
                              <p class="event__block-count">{{ block.interact.currentCount || 1 }}</p>
                              <button @click="updateCount(block, 1)"
                                :disabled="block.interact.currentCount >= block.interact.maxCount">
                                <i>
                                  <svg width="8" height="7" viewBox="0 0 8 7" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 0V7M0.5 3.5H7.5" stroke="#333333" />
                                  </svg>
                                </i>
                              </button>
                            </div>
                            <button class="login__btn event__block-reserve" :disabled="isLoading"
                              :class="{ 'login__btn--loading': isLoading, 'registered': beRegistered, 'registeredSuccess': beRegisteredSuccess }"
                              v-if="block.interact.action.type != 'phone'"
                              @click="handleAction(block.interact, selectedEvent)">

                              {{ isLoading ? 'Регистрируем…' : (this.errorText || block.interact.label) }}
                            </button>
                            <a v-else :href="'tel:' + block.interact.action.phone">
                              Позвонить
                            </a>
                            <!-- Сообщение об успешной или неудачной резервировании -->
                          </template>
                          <p v-if="reservationStatus"
                            :class="{ 'success-message': reservationStatus.success, 'error-message': !reservationStatus.success }">
                            {{ reservationStatus.message }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div v-if="deviceMobile" class="event__blocks">
            <div v-for="(block, index) in selectedEvent.blocks" :key="index" class="event__block">
              <!-- Вывод информации о блоке -->
              <div v-for="(info, idx) in block.info" :key="idx" class="event__info">
                <template v-if="info.type === 'message'">
                  <p>{{ info.message }}</p>
                </template>
                <template v-if="info.type === 'cost'">
                  <p class="event__block-price">Цена</p>
                  <p class="event__block-cost">{{ info.cost }}</p>
                </template>
                <template v-if="info.type === 'label_count'">
                  <div class="event__block-flex">
                    <p>{{ info.label }}</p>
                    <p class="event__block-count">{{ info.count }}</p>
                  </div>
                </template>
              </div>

              <!-- Вывод кнопок взаимодействия -->
              <div v-if="block.interact" class="event__interact">
                <template v-if="block.interact.type === 'button'">
                  <button class="login__btn" :disabled="isLoading"
                    :class="{ 'login__btn--loading': isLoading, 'registered': beRegistered, 'registeredSuccess': beRegisteredSuccess }"
                    v-if="block.interact.action.type != 'phone'" @click="handleAction(block.interact, selectedEvent)">

                    {{ isLoading ? 'Регистрируем…' : (this.errorText || block.interact.label) }}
                  </button>
                  <a v-else :href="'tel:' + block.interact.action.phone">
                    Позвонить
                  </a>
                </template>

                <template v-if="block.interact.type === 'button_count'">
                  <div class="event__counter">
                    <button @click="updateCount(block, -1)" :disabled="block.interact.currentCount <= 0">
                      <i>
                        <svg width="8" height="1" viewBox="0 0 8 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0.5 0.5H7.5" stroke="#333333" />
                        </svg>
                      </i>
                    </button>
                    <p class="event__block-count">{{ block.interact.currentCount || 1 }}</p>
                    <button @click="updateCount(block, 1)"
                      :disabled="block.interact.currentCount >= block.interact.maxCount">
                      <i>
                        <svg width="8" height="7" viewBox="0 0 8 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 0V7M0.5 3.5H7.5" stroke="#333333" />
                        </svg>
                      </i>
                    </button>
                  </div>
                  <button class="login__btn" :disabled="isLoading"
                    :class="{ 'login__btn--loading': isLoading, 'registered': beRegistered, 'registeredSuccess': beRegisteredSuccess }"
                    v-if="block.interact.action.type != 'phone'" @click="handleAction(block.interact, selectedEvent)">

                    {{ isLoading ? 'Регистрируем…' : (this.errorText || block.interact.label) }}

                  </button>
                  <a v-else :href="'tel:' + block.interact.action.phone">
                    Позвонить
                  </a>
                </template>
                <p v-if="reservationStatus"
                  :class="{ 'success-message': reservationStatus.success, 'error-message': !reservationStatus.success }">
                  {{ reservationStatus.message }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <OrganizerModal v-if="isModalVisible" :organizerId="selectedOrganizerId" @close="isModalVisible = false" />
  <Footers />
  <transition>
    <LoginModal v-if="showLoginModal" :isVisible="showLoginModal" @close="showLoginModal = false"
      @refresh-events="refreshEvents" />
  </transition>
  <SignUpEvent v-if="showSignUpEvent" @refresh="refreshPlaces" :event="eventForModal" :count="countForModal"
    :requiredPhone="requiredPhone" @close="closeSignUpEvent" />
  <SignUpEventMulti v-if="showSignUpEventMulti" @refresh="refreshPlaces" :event="eventForModal" :count="countForModal"
    :requiredPhone="requiredPhone" @close="closeSignUpEventMulti" />
  <Thank v-if="showThank" :eventTitle="selectedEvent.title" @close="this.showThank = false;" />
  <Error v-if="showError" :errorText="errorText" @close="showError = false" />
</template>

<script>

import axios from 'axios'
axios.defaults.headers.common['X-API-KEY'] = 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1';
import Headers from '@/components/Headers.vue'
import Footers from '@/components/Footers.vue'
import LoginModal from '@/components/LoginModal.vue';
import SignUpEvent from '@/components/SignUpEvent.vue';
import OrganizerModal from '@/components/OrganizerModal.vue';
import metka1 from '@/assets/img/metka1.png';
import metka2 from '@/assets/img/metka2.png';
import metka3 from '@/assets/img/metka3.png';
import EventsMenu from '@/components/EventsMenu.vue';
import MarkersPanel from '@/components/MarkersPanel.vue';
import Schedule from '@/components/Schedule.vue';
import SignUpEventMulti from '@/components/SignUpEventMulti.vue';
import Thank from "../components/Thank.vue";
import Error from "../components/Error.vue";
import PosterImage from "../components/PosterImage.vue";


export default {
  name: 'HomeView',
  components: {
    Headers,
    Footers,
    EventsMenu,
    LoginModal,
    SignUpEvent,
    SignUpEventMulti,
    OrganizerModal,
    Schedule,
    MarkersPanel,
    Thank,
    Error,
    PosterImage
  },
  data() {
    return {
      times: Array.from({ length: 24 }, (_, i) => `${i}:00`), // Массив с временем с 00:00 до 23:00
      currentDateForWeek: new Date(),
      currentDateForMonth: new Date(),
      showEventsPopup: false,
      currentDayEvents: [],
      page: '',
      currentWeek: [],
      events: [],
      eventsForCalendar: [],
      eventForPopup: {},
      weekdays: ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'],
      timeSlots: [...Array(24).keys()].map(i => `${i.toString().padStart(2, '0')}:00`),
      selectedDateText: 'на сегодня',
      selectedDateTextPlaceHolder: 'на сегодня',
      filteredEvents: [],
      isLinkCopied: false,
      mapEventLink: null,
      selectedEvent: null, // Переменная для хранения выбранного мероприятия
      map: null,
      showEventModal: false,
      isPopupVisible: false, // Флаг видимости попапа
      selectedDay: null,
      imageCache: {},
      processedImages: {}, // Реактивное свойство для обработанных изображений
      loading: true,
      loadingTimeout: null, // таймер для загрузки
      timeoutDuration: 500, // время задержки в мс, можно настроить
      isWaitingForLoading: false, // промежуточный флаг
      scrollPosition: 0,
      flagNewEvents: false,
      calendarStart: "2024-05-01T00:00:00",
      calendarEnd: "2024-06-01T00:00:00",
      calendarCategories: [],
      activeMenuItem: 1,
      showLoginModal: false,
      showSignUpEvent: false,
      showSignUpEventMulti: false,
      requiredPhone: false,
      isModalVisible: false,            // Показывает, видно ли модальное окно
      selectedOrganizerId: null,
      eventMapShow: false,
      errorMessage: '',
      count: 1, // Переменная для хранения сообщения об ошибке
      reservationStatus: null,
      deviceMobile: false, // Для хранения статуса сообщения
      deviceMobileTry: false, // Для хранения статуса сообщения
      screenWidth: window.innerWidth,
      selectedEvent: null, // Данные о событии
      selectedCount: 1,    // Количество мест
      eventForModal: {},
      countForModal: 1,
      showThank: false,
      showError: false,
      errorText: null,
      isLoading: false,
      beRegistered: false,
      beRegisteredSuccess: false,
      myMap: null,
    };
  },
  watch: {
    eventsForCalendar: {
      handler() {
        this.$forceUpdate();
        this.loading = false;
      },
      deep: true
    }
  },
  created() {
    this.checkAndOpenPopup();
    this.currentWeek = this.getWeekDays();
    this.weekdays = this.getWeekDays();
    this.decktopVisible();
  },
  updated() {
    // После обновления компонента добавляем обработчики событий
    this.addEventHandlers();
  },
  computed: {
    // FOR WEEK 
    weekDateRange() {
      if (this.weekdays.length === 0) return ''; // Проверка на наличие данных
      const startDate = this.weekdays[0].date;
      const endDate = this.weekdays[this.weekdays.length - 1].date;
      const startDay = startDate.getDate();
      const endDay = endDate.getDate();
      const startMonth = startDate.toLocaleString('default', { month: 'long' });
      const endMonth = endDate.toLocaleString('default', { month: 'long' });
      const startYear = startDate.getFullYear();
      const endYear = endDate.getFullYear();
      // Форматируем строку для отображения диапазона дат и месяца
      const dateRangeString = `${startDay}-${endDay} ${startMonth}`;
      // Добавляем год, если первый и последний день недели в разных годах
      if (startYear !== endYear) {
        return `${dateRangeString} ${startYear}-${endYear}`;
      } else {
        return dateRangeString;
      }
    },
    // FOR WEEK 

    // FOR MONTH 
    currentDateText() {
      if (this.selectedDay !== null) {
        const selectedDate = new Date(this.currentDateForMonth);
        selectedDate.setDate(this.selectedDay.getDate());
        return selectedDate.toLocaleString('default', { day: 'numeric', month: 'long' });
      } else {
        return this.currentDateForMonth.toLocaleString('default', { month: 'long' });
      }
    },
    currentMonth() {
      return this.currentDateForMonth.toLocaleString('default', { month: 'long', year: 'numeric' });
    },
    daysInMonth() {
      const days = [];
      const currentDate = this.currentDateForMonth;
      const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
      const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();

      let prevMonthDays = firstDay === 0 ? 6 : firstDay - 1;
      let nextMonthDays = 0;

      if (firstDay !== 0) {
        prevMonthDays = firstDay - 1;
      }

      const totalDays = prevMonthDays + lastDayOfMonth;
      const totalWeeks = Math.ceil(totalDays / 7);
      const totalCells = totalWeeks * 7;

      if (totalCells === 35) {
        nextMonthDays = 35 - totalDays;
      } else if (totalCells === 42) {
        nextMonthDays = 42 - totalDays;
      } else {
        nextMonthDays = 7 - ((totalDays % 7) || 7);
      }

      // Добавляем дни предыдущего месяца
      for (let i = prevMonthDays; i > 0; i--) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), -i + 1);
        days.push({ date, events: this.getEventsForDate(date) });
      }

      // Добавляем дни текущего месяца
      for (let i = 1; i <= lastDayOfMonth; i++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
        days.push({ date, events: this.getEventsForDate(date) });
      }

      // Добавляем дни следующего месяца
      for (let i = 1; i <= nextMonthDays; i++) {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, i);
        days.push({ date, events: this.getEventsForDate(date) });
      }

      return days;
    },

    isPrevMonthDisabled() {
      return new Date().getFullYear() === this.currentDateForMonth.getFullYear() && new Date().getMonth() === this.currentDateForMonth.getMonth();
    },
    isNextMonthDisabled() {
      return false;
    }
    // FOR MONTH 
  },
  methods: {
    async refreshEvents() {
      this.$refs.headers.refreshEvents();
      this.showLoginModal = false;

    },
    async refreshPlaces() {
      await this.fetchEvents(this.selectedEvent.id)
      this.$refs.headers.refreshEvents();
    },
    openSignUpEvent(payload) {
      this.eventForModal = payload.event; // Сохраняем данные о событии
      this.countForModal = payload.count; // Сохраняем количество мест
      this.requiredPhone = payload.requiredPhone; // Сохраняем количество мест
      this.showSignUpEvent = true; // Открываем модальное окно      
    },
    openSignUpEventMulti(payload) {
      this.eventForModal = payload.event; // Сохраняем данные о событии
      this.countForModal = payload.count; // Сохраняем количество мест
      this.requiredPhone = payload.requiredPhone; // Сохраняем количество мест
      this.showSignUpEventMulti = true; // Открываем модальное окно      
    },
    decktopVisible() {
      if (window.innerWidth < 1025) {
        this.deviceMobile = true;
      } else {
        this.deviceMobile = false;
      }
      if (window.innerWidth < 640) {
        this.deviceMobileTry = true;
      } else {
        this.deviceMobileTry = false;
      }
    },
    successSignUp() {
      this.beRegisteredSuccess = true;
      this.errorText = "Уже зарезервированы";
      this.showThank = false;
    },
    async handleAction(interact, event) {
      if (interact.action.type === 'phone') {
        window.location.href = `tel:${interact.action.phone}`;
      } else if (interact.action.type === 'url') {
        let url = interact.action.url;

        if (!url.startsWith('http://') && !url.startsWith('https://')) {
          url = 'https://' + url;
        }

        window.open(url, '_blank');

      } else {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));

        if (interact.action.registration === 'fast') {
          if (userInfo) {
            this.isLoading = true;
            const requestBody = {
              eventId: event.id,
              reservCount: interact.currentCount || 1,
              name: userInfo.name,
              surname: userInfo.surname,
              email: userInfo.email,
              phone: userInfo.phone,
            };

            const config = {
              headers: {
                'Content-Type': 'application/json',
              },
            };

            axios
              .post('/api/pis/v1/for_account/reserv', requestBody, config)
              .then(response => {
                this.refreshPlaces();
                this.isLoading = false;
                this.beRegisteredSuccess = true;
                this.errorText = "Уже зарезервированы";
              })
              .catch(error => {
                this.isLoading = false;
                this.beRegistered = true;
                this.errorText = "Уже зарезервированы";
              });
          } else {
            if (interact.action.type == 'reserv') {
              this.openSignUpEvent({
                event: event,
                count: interact.currentCount || 1,
                requiredPhone: false,
              });
            } else {
              this.openSignUpEventMulti({
                event: event,
                count: interact.currentCount || 1,
                requiredPhone: false,
              });
            }
          }
        } else if (interact.action.registration === 'requiredPhone') {
          if (interact.action.type == 'reserv') {
            this.openSignUpEvent({
              event: event,
              count: interact.currentCount || 1,
              requiredPhone: true,
            });
          } else {
            this.openSignUpEventMulti({
              event: event,
              count: interact.currentCount || 1,
              requiredPhone: true,
            });
          }
        } else {
          if (interact.action.type == 'reserv') {
            this.openSignUpEvent({
              event: event,
              count: interact.currentCount || 1,
              requiredPhone: false,
            });
          } else {
            this.openSignUpEventMulti({
              event: event,
              count: interact.currentCount || 1,
              requiredPhone: false,
            });
          }
        }
      }
    },
    updateCount(block, delta) {
      if (!block.interact.currentCount) block.interact.currentCount = 1;
      this.count = block.interact.currentCount + delta;
      if (this.count >= 1 && this.count <= block.interact.maxCount) {
        block.interact.currentCount = this.count;
      }
    },
    openOrganizerModal(event, organizerId) {
      if (organizerId) {
        event.stopPropagation();
        this.selectedOrganizerId = organizerId;  // Сохраняем ID организатора
        this.isModalVisible = true;              // Отображаем модальное окно
      }
    },
    getDayClass(daysInMonth) {
      let className = '';
      if (this.daysInMonth.length === 28) {
        className += 'week4 ';
      } else if (this.daysInMonth.length == 35) {
        className += 'week5 ';
      } else if (this.daysInMonth.length == 42) {
        className += 'week6 ';
      }
      return className.trim();
    },
    setFirstEventByTitle() {
      const firstEventTitles = new Set();
      const eventTitleElements = document.getElementsByClassName('week__event-title');
      for (const titleElement of eventTitleElements) {
        const eventTitle = titleElement.textContent.trim();
        if (!firstEventTitles.has(eventTitle)) {
          firstEventTitles.add(eventTitle);
          let currentElement = titleElement;
          while (currentElement && !currentElement.classList.contains('week__event')) {
            currentElement = currentElement.parentElement;
          }
          if (currentElement) {
            currentElement.classList.add('first');
          }
        }
      }
    },
    getEventTimeSlots() {
      return this.timeSlots;
    },
    isEventInDayAndTime(event, date, time) {

      const eventStartTime = new Date(event.startTime);
      const eventEndTime = new Date(event.finishTime);
      const targetDay = new Date(date);
      const [hours, minutes] = time.split(':');

      targetDay.setHours(parseInt(hours), parseInt(minutes), 0, 0);

      return eventStartTime <= targetDay && eventEndTime > targetDay;

    },
    // FOR WEEK 
    isTodayWeek(date) {
      const today = new Date(); // Получаем текущую дату
      // Проверяем, является ли дата сегодняшней
      const isToday = date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth() &&
        date.getDate() === today.getDate();
      return isToday;
    },
    isPastDay(date) {
      const today = new Date();
      // Очищаем время у даты (сравниваем только по дате)
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);

      return date < today;  // Если дата меньше текущей, значит это прошлый день
    },
    getWeekDays() {
      setTimeout(() => {
        this.setFirstEventByTitle();
      }, 100);
      const daysOfWeek = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];
      const startOfWeek = this.getWeekStartDate(this.currentDateForWeek);
      const weekDays = [];
      for (let i = 0; i < 7; i++) {
        const date = new Date(startOfWeek);
        date.setDate(date.getDate() + i);
        weekDays.push({ dayOfWeek: daysOfWeek[i], date: date });
      }
      return weekDays;
    },
    getDateInCurrentWeek(dayOfWeek) {
      return dayOfWeek.getDate();
    },
    getDateInCurrentWeekForToday(dayOfWeek) {
      const currentWeekDays = this.getWeekDays(); // Получаем даты текущей недели
      const currentDate = currentWeekDays[dayOfWeek]; // Получаем дату для указанного дня недели
      return currentDate.date; // Возвращаем объект даты
    },

    getWeekStartDate(date) {
      const dayOfWeek = date.getDay(); // Получаем день недели (0 - воскресенье, 1 - понедельник, ..., 6 - суббота)
      const diff = (dayOfWeek === 0 ? 6 : dayOfWeek - 1); // Вычисляем разницу между днем недели и понедельником (если воскресенье, то 6 дней назад)
      const startOfWeek = new Date(date); // Создаем новый объект Date на основе переданной даты
      startOfWeek.setDate(date.getDate() - diff); // Устанавливаем дату на начало текущей недели
      return startOfWeek; // Возвращаем начальную дату недели
    },

    nextWeek() {
      setTimeout(() => {
        this.setFirstEventByTitle();
      }, 100);
      this.currentDateForWeek.setDate(this.currentDateForWeek.getDate() + 7);
      this.weekdays = this.getWeekDays(); // Обновляем массив дней недели
    },

    prevWeek() {
      setTimeout(() => {
        this.setFirstEventByTitle();
      }, 100);
      this.currentDateForWeek.setDate(this.currentDateForWeek.getDate() - 7);
      this.weekdays = this.getWeekDays(); // Обновляем массив дней недели
    },
    isPrevWeekDisabled() {
      const today = new Date();
      const startOfCurrentWeek = this.getWeekStartDate(today);
      const startOfSelectedWeek = this.getWeekStartDate(this.currentDateForWeek);
      const isToday = startOfCurrentWeek.getFullYear() === startOfSelectedWeek.getFullYear() &&
        startOfCurrentWeek.getMonth() === startOfSelectedWeek.getMonth() &&
        startOfCurrentWeek.getDate() === startOfSelectedWeek.getDate();
      return isToday;
    },
    // FOR WEEK 

    // FOR MONTH 
    showPopupEvents(events, date) {
      document.querySelector('html').classList.add('showPopup');
      setTimeout(() => {
        document.querySelector('html').classList.add('animShowPopup');
      }, 10);


      const formatDateShort = (date) => {
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      };

      const formatedDate = formatDateShort(date);

      let categoriesCode = this.$refs.headers.getCategoriesValue();
      let eventId = null;
      if (this.selectedEvent) {
        eventId = this.selectedEvent.id;
      }
      this.$refs.headers.sendInfoToManager(this.page || '', eventId, formatedDate, categoriesCode);

      this.currentDayEvents = events;
      this.showEventsPopup = true;
    },
    hidePopupEvents() {
      const formatDateShort = (date) => {
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
      };

      const formattedCurrentDate = formatDateShort(this.currentDateForMonth);
      const todayFormattedDate = formatDateShort(new Date());
      let categoriesCode = this.$refs.headers.getCategoriesValue();
      this.$refs.headers.dateForCalendar = null;

      if (formattedCurrentDate === todayFormattedDate) {
        this.$refs.headers.sendInfoToManager(this.page || '', null, null, categoriesCode);
      } else {
        this.$refs.headers.sendInfoToManager(this.page || '', null, formattedCurrentDate, categoriesCode);
      }

      document.querySelector('html').classList.remove('animShowPopup');
      setTimeout(() => {
        document.querySelector('html').classList.remove('showPopup');
      }, 500);
      this.showEventsPopup = false; // Скрываем попап
    },
    getEventLink(event) {
      const mapBaseLink = `${window.location.origin}`;
      return `${mapBaseLink}?eventId=${event.id}`;
    },
    isToday(day) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return (day.getTime() === today.getTime());
    },

    async prevMonth() {
      this.loading = true;
      this.$refs.headers.loading = true;
      this.currentDateForMonth = new Date(this.currentDateForMonth.getFullYear(), this.currentDateForMonth.getMonth() - 1, 1);
      this.handleCategoriesFilter(0)
    },
    async nextMonth() {
      this.loading = true;
      this.$refs.headers.loading = true;
      this.currentDateForMonth = new Date(this.currentDateForMonth.getFullYear(), this.currentDateForMonth.getMonth() + 1, 1);
      this.handleCategoriesFilter(0)
    },
    getEventsForDate(date) {
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const dateString = `${year}-${month}-${day}`; // Форматируем дату как YYYY-MM-DD

      const dayData = this.eventsForCalendar.find(day => day.date === dateString);

      return dayData ? dayData.events : [];
    },
    // FOR MONTH 
    shareEvent() {
      let baseLink = window.location.href;

      // Заменяем домен на кириллический
      baseLink = baseLink.replace('xn--b1adhhcro.xn--p1ai', 'мойдвиж.рф');

      // Копируем в буфер обмена
      navigator.clipboard.writeText(baseLink);
      this.isLinkCopied = true;

      // Сброс через 1.5 секунды
      setTimeout(() => {
        this.isLinkCopied = false;
      }, 1500);
    },

    initMap() {
      // Проверка наличия необходимых данных
      const latitude = this.selectedEvent?.point?.latitude;
      const longitude = this.selectedEvent?.point?.longitude;

      if (!latitude || !longitude) {
        return;
      }

      if (!this.$refs.mapContainer) {
        return;
      }


      let iconImageSize;

      if (this.screenWidth < 640) {
        iconImageSize = [30, 42];
      } else if (this.screenWidth < 1600) {
        iconImageSize = [35, 50];
      } else {
        iconImageSize = [61, 88];
      }

      try {
        // Если карта уже существует — просто обновим центр
        if (this.myMap) {
          this.myMap.setCenter([latitude, longitude]);
          return;
        }

        setTimeout(() => {
          if (!this.$refs.mapContainer) return;


          this.myMap = new ymaps.Map(this.$refs.mapContainer, {
            center: [latitude, longitude],
            zoom: 15,
            controls: [],
          });

          const placemark = new ymaps.Placemark(
            [latitude, longitude],
            {
              hintContent: 'Место проведения мероприятия',
            },
            {
              iconLayout: 'default#image',
              iconImageHref: metka3,
              iconImageSize: iconImageSize,
            }
          );

          this.myMap.geoObjects.add(placemark);

        }, 100);
      } catch (error) {
        console.error("Ошибка при инициализации Яндекс.Карты:", error);
      }
    },

    initMapList() {
      try {
        this.$refs.mapContainerList.innerHTML = '';

        // Создаем новую карту
        const myMap = new ymaps.Map(this.$refs.mapContainerList, {
          center: [53.195873, 50.100193], // Координаты центра карты (Самара)
          zoom: 10 // Уровень масштабирования карты
        });
        const now = new Date();
        // Добавляем метки на карту
        this.events.forEach(event => {
          if (event.point.latitude) {
            const latitude = event.point.latitude;
            const longitude = event.point.longitude;
            const startTime = new Date(event.startTime);
            const finishTime = new Date(event.finishTime);
            // Проверяем, проходит ли событие прямо сейчас
            if (now >= startTime && now <= finishTime) {
              var iconImageHref = metka2;
            } else {
              var iconImageHref = metka1;
            }
            var iconImageSize;
            if (this.screenWidth < 640) {
              iconImageSize = [30, 42];
            } else if (this.screenWidth < 1600) {
              iconImageSize = [35, 50];
            } else {
              iconImageSize = [61, 88];
            }

            const placemark = new ymaps.Placemark([latitude, longitude], {
              hintContent: event.shortTitle // В качестве подсказки используем название мероприятия
            }, {
              iconLayout: 'default#image',
              iconImageHref: iconImageHref, // Путь к SVG значку
              iconImageSize: iconImageSize, // Размеры значка
            });
            // Добавляем метку на карту
            myMap.geoObjects.add(placemark);

            placemark.events.add('click', (e) => {
              this.selectedEvent = null;
              this.showEventModal = false;
              setTimeout(() => {
                const id = event.id;
                const selectedEvent = this.events.find(event => event.id === id);
                this.selectedEvent = selectedEvent;
                const mapBaseLink = `${window.location.origin}`;
                this.mapEventLink = `${mapBaseLink}?eventId=${this.selectedEvent.id}`;
                this.showEventModal = true;
                document.querySelectorAll('ymaps').forEach(item => {
                  item.classList.add('modal-open');
                });
              }, 10);
            });
          }

        });
        myMap.events.add('click', () => {
          document.querySelectorAll('ymaps').forEach(item => {
            item.classList.remove('modal-open');
          });
          this.showEventModal = false;
          this.selectedEvent = null;
        });
      } catch (error) {
        console.error("Error initializing Yandex Map:", error);
      }
    },
    handleLoadingState(isLoading, page) {
      this.loading = isLoading;
      if (this.page !== '') {
        this.flagNewEvents = false;
      }
      this.page = page;

      // // Если запрос начал загружаться
      // if (isLoading) {
      //   // Если экран загрузки ещё не показывался и мы не ждём его, начинаем отсчёт
      //   if (!this.isWaitingForLoading) {
      //     this.isWaitingForLoading = true; // Устанавливаем флаг ожидания
      //     this.loadingTimeout = setTimeout(() => {
      //       this.loading = true; // Показываем экран загрузки через 100 мс
      //     }, this.timeoutDuration);
      //   }
      // } else {
      //   // Если запрос завершился, очищаем таймер и скрываем экран загрузки
      //   clearTimeout(this.loadingTimeout);
      //   this.isWaitingForLoading = false; // Сбрасываем флаг ожидания
      //   this.loading = false;
      //   this.$refs.headers.loading = false;
      // }
    },

    handleFilteredEvents(filteredEvents, selectedDateText, page) {
      this.selectedDateText = selectedDateText;
      this.page = page;
      this.selectedDateTextPlaceHolder = "в выбранный день недели";
      this.events = filteredEvents;
      setTimeout(() => {
        if (this.page === 'map') {
          if (!this.map) {
            this.initMapList();
          }
        }
      }, 1);
      if (page === '') {
        this.flagNewEvents = true;
      } else {
        this.flagNewEvents = false;
      }
      this.showEventModal = false;
    },
    async handleCategoriesFilter(categories, date) {

      this.loading = true;
      if (categories !== 0) {
        this.calendarCategories = categories;
      }

      let fullDateToShow = null;

      if (date) {
        console.log('date:', date);
        const parts = date.split('-');

        if (parts.length === 2) {
          const [year, month] = parts.map(Number);
          const firstOfMonth = new Date(year, month - 1, 1);
          this.currentDateForMonth = firstOfMonth;
        } else if (parts.length === 3) {
          const [year, month] = parts.map(Number);
          const firstOfMonth = new Date(year, month - 1, 1);
          this.currentDateForMonth = firstOfMonth;

          // Сохраняем полную дату
          fullDateToShow = new Date(year, month - 1, Number(parts[2]));
        }
      }



      // Преобразуем даты из daysInMonth в нужный формат
      let startDate = this.daysInMonth[0].date;
      let endDate = this.daysInMonth[this.daysInMonth.length - 1].date;
      // Добавляем и вычитаем по одному дню для startDate и endDate
      endDate = new Date(endDate);
      endDate.setDate(endDate.getDate() + 1);
      startDate = new Date(startDate);
      startDate.setDate(startDate.getDate() - 1);

      const formatDate = (date) => {
        const d = new Date(date);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T00:00:00`;
      };
      this.calendarStart = formatDate(startDate);
      this.calendarEnd = formatDate(endDate);
      const apiUrl = '/api/pis/v1/events/events_by_days';

      const queryParams = new URLSearchParams({
        start: this.calendarStart,
        end: this.calendarEnd,
        struct: 'false',
        categories: this.calendarCategories,
      });

      // Отмена предыдущего запроса, если он существует
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Новый запрос отменяет предыдущий.');
      }

      // Создаем новый токен отмены
      this.cancelTokenSource = axios.CancelToken.source();


      // Настроим конфигурацию с заголовками только если токен есть
      const config = {
        cancelToken: this.cancelTokenSource.token, // Если токена нет, добавляем только токен отмены
      };

      try {
        const response = await axios.get(`${apiUrl}?${queryParams}`, config);
        this.eventsForCalendar = response.data;

        if (fullDateToShow) {

          // Клонируем дату, чтобы не мутировать оригинал (на всякий случай)
          const adjustedDate = new Date(fullDateToShow);
          adjustedDate.setDate(adjustedDate.getDate() + 1);

          const targetDay = this.eventsForCalendar.find(entry => {
            return entry.date === adjustedDate.toISOString().slice(0, 10); // "YYYY-MM-DD"
          });


          if (targetDay && targetDay.events && targetDay.events.length > 0) {
            this.selectedDay = fullDateToShow;
            this.showPopupEvents(targetDay.events, fullDateToShow);
          }
        } else {
          const formatDateShort = (date) => {
            const d = new Date(date);
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
          };

          const formattedCurrentDate = formatDateShort(this.currentDateForMonth);
          const todayFormattedDate = formatDateShort(new Date());
          let categoriesCode = this.$refs.headers.getCategoriesValue();
          let event = null;
          if (this.selectedEvent) {
            this.$refs.headers.selectedEventId = this.selectedEvent.id;
            event = this.selectedEvent.id;
          }
          if (formattedCurrentDate === todayFormattedDate) {
            this.$refs.headers.sendInfoToManager(this.page || '', event, null, categoriesCode);
          } else {
            this.$refs.headers.sendInfoToManager(this.page || '', event, formattedCurrentDate, categoriesCode);
          }
        }


        this.loading = false;

      } catch (error) {
        if (axios.isCancel(error)) {
        } else {
          console.error('Ошибка при получении мероприятий:', error);
        }
      }
    },
    async fetchEvents(id) {
      this.$refs.headers.selectedEventId = id;

      const devParam = window.innerWidth > 1023 ? 'd' : 'm';
      const viewParam = 'c';

      const queryParams = new URLSearchParams({
        dev: devParam,
        view: viewParam,
      });

      const apiUrl = `/api/pis/v1/events/event/${id}?${queryParams}`;


      // Настраиваем конфигурацию с заголовками только если токен есть
      const config = {
        headers: {
          'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
          'Content-Type': 'application/json'
        }
      }

      try {
        const response = await axios.get(apiUrl, config); // Запрос с или без конфигурации
        this.openPopup(response.data);


        const { date = null, categories = null } = this.$route.query;
        this.$refs.headers.sendInfoToManager(this.page || '', id || null, date, categories);

      } catch (error) {
        this.unlockBodyScroll();
        document.querySelector('html').classList.remove('animShowPopup');
        setTimeout(() => {
          document.querySelector('html').classList.remove('showPopup');
        }, 500);
      }
    },
    checkAndOpenPopup() {
      const eventId = this.$route.query.eventId;
      if (eventId) {
        const eventIdNumber = parseInt(eventId, 10);
        this.fetchEvents(eventIdNumber);
      }
    },
    getDayDifference(startTime, finishTime) {
      // Преобразование в объекты дат
      const startDate = new Date(startTime);
      const finishDate = new Date(finishTime);

      const userTimezoneOffset = startDate.getTimezoneOffset() / 60 * -1;

      startDate.setHours(startDate.getHours() + userTimezoneOffset);
      finishDate.setHours(finishDate.getHours() + userTimezoneOffset);

      // Вычисление разницы в миллисекундах
      const timeDiff = finishDate - startDate;
      const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

      return dayDiff > 0 ? '+' + dayDiff : '';
    },
    formatDate(start, end) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const startDate = new Date(start);
      const endDate = new Date(end);

      const userTimezoneOffset = startDate.getTimezoneOffset() / 60 * -1

      startDate.setHours(startDate.getHours() + userTimezoneOffset)
      endDate.setHours(endDate.getHours() + userTimezoneOffset)


      const day = startDate.getDate();
      const month = months[startDate.getMonth()];
      const hours = startDate.getHours().toString().padStart(2, '0');
      const minutes = startDate.getMinutes().toString().padStart(2, '0');

      const endHours = endDate.getHours().toString().padStart(2, '0');
      const endMinutes = endDate.getMinutes().toString().padStart(2, '0');

      return `${day} ${month}, ${hours}:${minutes} - ${endHours}:${endMinutes}`;
    },
    formatDateTimeForPopup(startTime, endTime) {
      const days = [
        'Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'
      ];
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const start = new Date(startTime);
      const end = new Date(endTime);

      // День недели, день и месяц
      const dayOfWeek = days[start.getDay()];
      const day = start.getDate();
      const month = months[start.getMonth()];


      const userTimezoneOffset = start.getTimezoneOffset() / 60 * -1

      start.setHours(start.getHours() + userTimezoneOffset)
      end.setHours(end.getHours() + userTimezoneOffset)

      // Время начала и окончания
      const startHours = start.getHours().toString().padStart(2, '0');
      const startMinutes = start.getMinutes().toString().padStart(2, '0');
      const endHours = end.getHours().toString().padStart(2, '0');
      const endMinutes = end.getMinutes().toString().padStart(2, '0');

      // Формируем строки времени и даты отдельно
      const timeString = `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
      const dateString = `${dayOfWeek}, ${day} ${month}`;

      // Возвращаем объект с разделёнными строками
      return { time: timeString, date: dateString };
    },

    formatDateTime(start, end) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const date = new Date(start);
      const endDate = new Date(end);

      const userTimezoneOffset = date.getTimezoneOffset() / 60 * -1

      date.setHours(date.getHours() + userTimezoneOffset)
      endDate.setHours(endDate.getHours() + userTimezoneOffset)

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      const endHours = endDate.getHours().toString().padStart(2, '0');
      const endMinutes = endDate.getMinutes().toString().padStart(2, '0');

      return `${hours}:${minutes}-${endHours}:${endMinutes}`;
    },
    formattedDescr(description) {
      let formattedDescription = description.replace(/\n/g, '<br>');
      return formattedDescription;
    },
    formatDatePopup(timestamp) {
      const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
      ];

      const date = new Date(timestamp);
      const day = date.getDate();
      const month = months[date.getMonth()];

      return `${day} ${month}`;
    },
    formatTimePopup(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);

      const userTimezoneOffset = start.getTimezoneOffset() / 60 * -1;

      start.setHours(start.getHours() + userTimezoneOffset);
      end.setHours(end.getHours() + userTimezoneOffset);

      const startHours = start.getHours().toString().padStart(2, '0');
      const startMinutes = start.getMinutes().toString().padStart(2, '0');

      const endHours = end.getHours().toString().padStart(2, '0');
      const endMinutes = end.getMinutes().toString().padStart(2, '0');

      // Проверка, если текущая страница - 'map'
      if (this.page === 'map') {
        return `С ${startHours}:${startMinutes} до ${endHours}:${endMinutes}`;
      }

      // Формат по умолчанию
      return `${startHours}:${startMinutes} - ${endHours}:${endMinutes}`;
    },

    openPopup(event) {
      if (event) {
        this.selectedEvent = event;
        this.isPopupVisible = true;
        // this.scrollPosition = window.scrollY;
        this.lockBodyScroll();
        document.querySelector('html').classList.add('showPopup');
        setTimeout(() => {
          document.querySelector('html').classList.add('animShowPopup');
        }, 10);
      }
    },
    hideEventsPopupAndOpenPopup(event) {
      // this.showEventsPopup = false; // Скрываем попап
      this.fetchEvents(event.id)
    },
    closePopup() {
      this.isPopupVisible = false;
      this.eventMapShow = false;
      this.beRegistered = false;
      this.beRegisteredSuccess = false;
      this.errorText = null;
        this.$refs.headers.selectedEventId = null;
      if (this.page !== "map"){
        this.selectedEvent = null;
      }
      this.myMap = null;
      document.querySelector('html').classList.remove('animShowPopup');
      this.unlockBodyScroll();
      setTimeout(() => {
        document.querySelector('html').classList.remove('showPopup');
      }, 500);

      const { date = null, categories = null } = this.$route.query;
      this.$refs.headers.sendInfoToManager(this.page || '', null, date, categories);


    },
    addEventHandlers() {
      this.$nextTick(() => {
        if (this.$refs.eventsInner) {
          let events = this.$refs.eventsInner.querySelectorAll('.events__item');
          events.forEach(item => {
            item.addEventListener('click', () => {
              this.openPopup(item.dataset.eventId); // Передаем идентификатор мероприятия
            });
          });
        }

      });


    },
    async toggleFav(event, item, fromPopup) {
      event.stopPropagation();

      const userInfo = JSON.parse(localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo'));

      if (!userInfo) {
        this.showLoginModal = true;
        return;
      }

      try {
        const config = {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            'Content-Type': 'application/json'
          }
        };

        if (!item.favorite) {
          // Добавление в избранное
          const response = await axios.post(
            `/api/pis/v1/for_account/to_favorite?event_id=${item.id}`,
            {},
            config
          );

          // Успешно добавлено в избранное
          if (response.status === 200) {
            item.favorite = true;
            item.favoriteCount += 1;
            if (fromPopup) {
              // Ищем событие с нужным id в массиве events
              const eventToFav = this.events.find(e => e.id === item.id);

              // Если событие найдено, устанавливаем favorite в true
              if (eventToFav) {
                eventToFav.favorite = true;
                eventToFav.favoriteCount += 1;
              }
            }
          }

        } else {
          // Удаление из избранного
          const response = await axios.post(
            `/api/pis/v1/for_account/not_favorite?event_id=${item.id}`,
            {},
            config
          );

          // Успешно удалено из избранного
          if (response.status === 200) {
            item.favorite = false;
            item.favoriteCount -= 1;
            if (fromPopup) {
              // Ищем событие с нужным id в массиве events
              const eventToFav = this.events.find(e => e.id === item.id);

              // Если событие найдено, устанавливаем favorite в false
              if (eventToFav) {
                eventToFav.favorite = false;
                eventToFav.favoriteCount -= 1;
              }
            }
          }
        }
      } catch (error) {
        console.error('Ошибка при добавлении/удалении избранного:', error);
      }
    },
    selectAllEvents() {
      this.$refs.headers.selectAllEvents();
    },
    selectAccount() {
      this.$refs.headers.selectAccount();
    },
    selectCustomFilter() {
      this.$refs.headers.selectCustomFilter();
    },
    handleErrorText(errorText) {
      this.errorMessage = errorText;
    },
    onChangeMenuState(state) {
      this.activeMenuItem = state;
    },
    handleKeydown(event) {
      if (event.key === "Escape" && this.isPopupVisible) {
        this.closePopup();
      }
    },
    closeSignUpEvent(success) {
      if (success) {
        this.successSignUp()
      }
      this.showSignUpEvent = false;
    },
    closeSignUpEventMulti(success) {
      if (success) {
        this.successSignUp()
      }
      this.showSignUpEventMulti = false;
    },
    lockBodyScroll() {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.dataset.scrollY = scrollY;
    },
    unlockBodyScroll() {
      const scrollY = document.body.dataset.scrollY || '0';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY));
      delete document.body.dataset.scrollY;
    },
    getDateFromUrl() {
      const dateFromUrl = this.$route.query.date;
      if (!dateFromUrl) {
        return;
      }

      // Преобразуем yyyy-mm в Date (первый день месяца)
      const [year, month] = dateFromUrl.split('-').map(Number);
      const firstOfMonth = new Date(year, month - 1, 1);
      this.currentDateForMonth = firstOfMonth;
    }

  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);

    this.addEventHandlers();
    this.page = this.$refs.headers.page;

  }
};
</script>
